import { Button, Typography } from '@mui/material'
import { format as dateFnsFormat } from 'date-fns'
import { ru } from 'date-fns/locale'
import { isUndefined } from 'lodash'
import { FC } from 'react'
import { ModalDialogWrapper } from '../../components/ModalDialogWrapper'
import { usePackageSubscription } from '../../hooks/usePackageSubscription'
import { useProfileStore } from '../../store/storeProfile'
import { useWrapperStore } from '../../store/storeWrapper'

export const PackageSubscriptionUpdateDialog: FC = () => {
    const { isOpenUpdateSubscriptionDialog, setIsOpenUpdateSubscriptionDialog } = useWrapperStore(
        (state) => state,
    )

    const { subscriptionData } = usePackageSubscription()
    const { deposit } = useProfileStore((state) => state)

    const handleClose = () => {
        setIsOpenUpdateSubscriptionDialog(false)
    }

    const handleUpdateSubscription = () => {
        if (subscriptionData?.next_payment_sum && subscriptionData?.tariff_uuid) {
            deposit({
                amount: subscriptionData.next_payment_sum,
                tariff_uuid: subscriptionData.tariff_uuid,
                is_recurring: true,
            })
        }

        handleClose()
    }

    const isOpen =
        !isUndefined(subscriptionData) &&
        !!subscriptionData?.is_active &&
        isOpenUpdateSubscriptionDialog

    const paymentDate = subscriptionData?.next_payment_date
        ? dateFnsFormat(subscriptionData.next_payment_date, 'd MMMM yyyy', { locale: ru })
        : null

    return (
        <ModalDialogWrapper
            open={isOpen}
            handleClose={handleClose}
            title="У вас закончились коины"
            footerActions={
                <>
                    <Button variant="outlined" onClick={handleClose} fullWidth>
                        Отменить
                    </Button>
                    <Button variant="contained" fullWidth onClick={handleUpdateSubscription}>
                        Обновить подписку
                    </Button>
                </>
            }>
            <Typography variant="body2" sx={{ mb: 1 }}>
                Ваша подписка будет продлена <strong>{paymentDate}</strong>.
            </Typography>
            <Typography variant="body2">
                Если вы хотите пополнить баланс и продолжить работу прямо сейчас, вы можете продлить
                подписку сейчас, и ваша новая дата списания изменится на сегодняшнее число.
            </Typography>
        </ModalDialogWrapper>
    )
}
